import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getModel } from './selectors';
import * as actions from './actions';
import TrendCommentsComponent from './TrendCommentsComponent';
import PropTypes from 'prop-types';

const TrendCommentsContainer = (props) => {
    const { model, actions } = props;

    useEffect(() => {
        if (model.dateSelection.from && model.dateSelection.to) {
            actions.resetTrendCommentSelection();
            actions.getTrendCommentsRequest();
        }
    }, [model.dateSelection, model.selectedTrendKPIs]);

    return <TrendCommentsComponent {...props} />;
};

TrendCommentsContainer.propTypes = {
    model: PropTypes.shape({
        dateSelection: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        }),
        selectedTrendKPIs: PropTypes.array
    }).isRequired,
    actions: PropTypes.shape({
        getTrendCommentsRequest: PropTypes.func.isRequired,
        resetTrendCommentSelection: PropTypes.func.isRequired
    }).isRequired
};


const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const TrendCommentsContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(TrendCommentsContainer);

export default TrendCommentsContainerConn;
